import {Row} from 'antd';
import React from 'react';
import { ScrollOnMount } from '../StudyContent';
import EditCriterionHes from "./EditCriterionHes";
import EditCriterionPcad from "./EditCriterionPcad";
import {Criterion, Query} from "../../HealthcareUsageReport/types/CohortQuery";


export type EditCriterionProps = {
    query: Query,
    criterion: Criterion,
    onChange: (criterion: Criterion) => void,
    onFormReady: (formReady: boolean) => void
}


const EditCriterion = ({query, criterion, onChange, onFormReady}: EditCriterionProps) => {

    const isPrimaryCare = query.dataset === "OPCRD";
    const isHes = query.dataset === "HES";

    return (<div className="criteria">
        <ScrollOnMount />
            <Row className="section">
                {isPrimaryCare && <EditCriterionPcad
                    criterion={criterion}
                    onFormReady={onFormReady}
                    onChange={(criterionPcad) => onChange(criterionPcad)}/>}
                {isHes && <EditCriterionHes
                    criterion={criterion}
                    onFormReady={onFormReady}
                    onChange={(criteriaHes) => onChange(criteriaHes)}/>
                }
        </Row>
    </div>)

}

export default EditCriterion